import localforage from "localforage";

const COUPLE_NOTE_REPORT_CONTEXT_KEY = "couple_note_report_context";

export const setCoupleNoteReportContext = async ({
  partnerId,
  clientPartnerMappingId,
  partnerName,
}) => {
  if (!partnerId || !clientPartnerMappingId) return;

  await localforage.setItem(COUPLE_NOTE_REPORT_CONTEXT_KEY, {
    partnerId,
    clientPartnerMappingId,
    partnerName: partnerName || null,
  });
};

export const getCoupleNoteReportContext = async () => {
  const context = await localforage.getItem(COUPLE_NOTE_REPORT_CONTEXT_KEY);
  return context || null;
};

export const clearCoupleNoteReportContext = async () => {
  await localforage.removeItem(COUPLE_NOTE_REPORT_CONTEXT_KEY);
};
